import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { handleToggleChat, setProvider } from '../../../store/slices/generalSlice';
import { ContentLayout, FormLayout } from '../../../global-styles/layout';
import WantToCallMe from '../../../components/want-to-call-me/WantToCallMe';
import ChatContact from '../../../components/chat-contact/ChatContact';
import AlxButton from '../../../components/alx-components/button';
import { images } from '../../../assets/images/images';
import { HasAssistanceStyles } from './has-assistance';

interface HasAssistanceInlineProps {
  entityCode: string | undefined;
  isChatAllowed: boolean | undefined;
  intervention: string;
  assistanceDate: Date | string | null;
  onNewAssistance: () => void;
}

const HasAssistanceInline = ({
  entityCode,
  isChatAllowed,
  intervention,
  assistanceDate,
  onNewAssistance,
}: HasAssistanceInlineProps) => {
  const { t } = useTranslation(['common', 'hasAssistance']);
  const dispatch = useDispatch();

  const [contact, setContact] = useState<boolean>(false);
  const [chatSelected] = useState<boolean>(false);
  const [wantToCallmeSelected, setWantToCallmeSelected] = useState<boolean>(false);

  const formattedAssistanceDate = (() => {
    if (!assistanceDate) return '';
    if (assistanceDate instanceof Date) return assistanceDate.toLocaleDateString();

    const parsedDate = new Date(assistanceDate);
    return Number.isNaN(parsedDate.getTime()) ? assistanceDate : parsedDate.toLocaleDateString();
  })();

  useEffect(() => {
    dispatch(setProvider({ provider: entityCode }));
  }, [dispatch, entityCode]);

  return (
    <ContentLayout data-cy="has-assistance-page">
      {!chatSelected && !wantToCallmeSelected && (
        <HasAssistanceStyles>
          <div className="onboarding-top">
            <div className="invalid-text">{t('hasAssistance:text1', { assistanceDate: formattedAssistanceDate })}</div>
            <div className="invalid-text">{t('hasAssistance:text2')}</div>
            <div className="invalid-text">{t('hasAssistance:text3')}</div>
            <div className="truck-img">
              <img src={images.cars} alt="" />
            </div>
          </div>
          <FormLayout>
            <AlxButton onClick={onNewAssistance} data-cy="new-assistance-button">
              {t('hasAssistance:new-assistance-button')}
            </AlxButton>
            <AlxButton onClick={() => setContact(true)} data-cy="contact-button">
              {t('hasAssistance:contact-button')}
            </AlxButton>
          </FormLayout>
          {contact && (
            <FormLayout className="contact-block">
              {isChatAllowed && (
                <AlxButton
                  onClick={() => dispatch(handleToggleChat())}
                  data-cy="contact-chat-button"
                  disabled={!isChatAllowed}
                >
                  {t('hasAssistance:contact-chat-button')}
                </AlxButton>
              )}
              <AlxButton
                onClick={() => setWantToCallmeSelected(true)}
                data-cy="contact-call-button"
                disabled={!intervention}
              >
                {t('hasAssistance:contact-call-button')}
              </AlxButton>
            </FormLayout>
          )}
        </HasAssistanceStyles>
      )}
      {chatSelected && <ChatContact />}
      {wantToCallmeSelected && <WantToCallMe intervention={intervention} />}
    </ContentLayout>
  );
};

export default HasAssistanceInline;
